import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chat"}/>
}
